module.exports = function () {
    $(document).ready(function () {

        /************
        * VARIABLES *
        *************/

        var helper = require('./helper');
        var AjaxController = require('./services/AjaxController');

        var roomsInjectBox = $('#rooms-box');
        var propertyInjectBox = $('#inject-property-box');
        var propertyInjectMsg = $('#inject-property-box-msg');
        var propertyInjectId = $('#inject-property-id');
        var propertyInjectName = $('#inject-property-name');
        var propertyInjectAddress = $('#inject-property-address');
        var propertyInjectPostcode = $('#inject-property-postcode');
        var hiddenPropertyId = $('#hidden-property-id');
        var hiddenRoomId = $('#hidden-room-id');
        var htmlSelected = '<span><i class="glyphicon glyphicon-ok"></i></span>Selected room';
        var htmlNotSelected = '<span><i class="glyphicon glyphicon-menu-right"></i></span>Select this room';


        /********************
         * TYPEAHEAD SECTION *
         *********************/
        /** Make engine object */
        var engine = new Bloodhound({
            datumTokenizer: function (datum) {
                return Bloodhound.tokenizers.whitespace(datum.name);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: helper.getOrigin() + "/api/properties/all/search/%QUERY",
                wildcard: '%QUERY'
            },
            filter: function (response) {
                return $.map(response.properties, function (object) {
                    return {
                        id: object.id,
                        name: object.name,
                        property_id: object.property_id
                    };
                });
            }
        });

        /** Run TypeAhead - init function */
        $('.typeahead').typeahead(null, {
            minLength: 1,
            display: 'name',
            valueKey: 'id',
            name: 'suggestions',
            displayKey: 'name',
            limit: 15,
            templates: {
                empty: ['<div class="empty-message" style="padding: 10px;"><strong>', 'Unable to find properties', '</strong></div>'].join('\n'),
                suggestion: function (data) {
                    return '<p style="font-size: 100%; cursor: pointer;"><strong>' + data.name + ' (' + data.property_id + ')' + '</strong></p>';
                }
            },
            source: engine
        });

        /*************************************
         * TYPEAHEAD SELECTED PROPERTY EVENT *
         *************************************/
        /**
         * Bind selected property event.
         * Populate property details and create rooms elements
         */
        $('#property').bind('typeahead:select', function (ev, suggestions) {

            var propertyId = suggestions.id;
            var url = '/api/properties/one/search';
            var data = { id: propertyId };

            /** Callback with instructions what to do with incoming response (properties collection) */
            var success = function (response) {

                /** Clear also selected room - field in form at the bottom of the page */
                hiddenRoomId.val('');

                /** Get variables from response  */
                var rooms = response.rooms;
                var property = response.property;

                /** Clear rooms box after property change */
                roomsInjectBox.empty();

                /** Show property overview ul */
                propertyInjectBox.show();
                propertyInjectMsg.hide();

                /** Inject property details */
                hiddenPropertyId.val(property.id);
                propertyInjectId.text(property.property_id);
                propertyInjectName.text(property.name);
                propertyInjectAddress.html(property.address_1 + "<br>" + property.address_2 + "<br>" + property.address_3);
                propertyInjectPostcode.text(property.postcode);

                /** Each room create box */
                if (rooms.length > 0) {
                    for (var i = 0; i < rooms.length; i++) {

                        /** Create room element */
                        var mainDiv = document.createElement('div');
                        $(mainDiv).addClass('col-md-4');

                        var mainContainer = document.createElement('div');
                        $(mainContainer).attr('id', 'room-information-' + rooms[i].id).addClass('room-information').css('background-color', '#0a7280').appendTo($(mainDiv));

                        var hidden = document.createElement('div');
                        $(hidden).attr('id', 'room-number-' + rooms[i].id).css('display', 'none').html(rooms[i].id).appendTo($(mainContainer));

                        var hidden2 = document.createElement('div');
                        $(hidden2).attr('id', 'room-name-' + rooms[i].id).css('display', 'none').html(rooms[i].name).appendTo($(mainContainer));

                        var hidden3 = document.createElement('div');
                        $(hidden3).attr('id', 'key-number-' + rooms[i].id).css('display', 'none').html(rooms[i].key).appendTo($(mainContainer));

                        var paragraph = document.createElement('p');
                        $(paragraph).addClass('room-number').css('padding', '6px').css('color', 'white').css('font-weight', 'bold').html('Room ' + rooms[i].name).appendTo($(mainContainer));

                        var ul = document.createElement('ul');
                        $(ul).addClass('room-information-in').attr('id', 'room-information-in-' + rooms[i].id).css('display', 'block');

                        var li1 = document.createElement('li');
                        $(li1).html('<i class="glyphicon glyphicon-user"></i>' + rooms[i].guardian).appendTo($(ul));

                        var li2 = document.createElement('li');
                        $(li2).html('<span style="width: 50%;"> Key number: </span> ' + rooms[i].key).appendTo($(ul));

                        var li3 = document.createElement('li');
                        $(li3).attr('id', 'label-select-this-room-' + rooms[i].id).css('background-color', '#e0e0e0');

                        var a = document.createElement('a');
                        $(a).attr('id', 'button-select-this-room-' + rooms[i].id).addClass('label-assign-to').css('cursor', 'pointer');
                        $(a).html(htmlNotSelected);

                        $(a).appendTo($(li3));
                        $(li3).appendTo($(ul));
                        $(ul).appendTo($(mainContainer));

                        /** Attach element to container */
                        $(roomsInjectBox).append(mainDiv);
                    }
                }
            }

            /** Define error callback */
            var error = function (response) {
                console.log('Error');
            }

            /** Send AJAX request */
            AjaxController.prototype.send(url, data, success, error);
        });


        /******************************
         * SELECT ROOM EVENT (EFFECT) *
         ******************************/
        /**
         * Selects room to report issue
         * Click event changes color of label and set id of selected room
         */
        $('#rooms-box').on('click', '[id^="label-select-this-room-"]', function () {

            /** Get ID of clicked label */
            var id = this.id.substring(23, this.id.length);

            /** Check (by color of label) whether room was already selected */
            if ($('#label-select-this-room-' + id).css('background-color') != "rgb(156, 255, 164)") {

                /** Set all labels as inactive*/
                $('[id^="button-select-this-room-"]').html(htmlNotSelected);
                $('[id^="label-select-this-room-"]').css('background-color', '#e0e0e0');

                /** Set selected label as active*/
                $('#button-select-this-room-' + id).html(htmlSelected);
                $('#label-select-this-room-' + id).css('background-color', "rgb(156, 255, 164)");

                /** Get values from selected room container and put it to one html variable */
                var roomId = $('#room-number-' + id).text();
                hiddenRoomId.val(roomId);

            } else {

                /** Set as not selected and clear box */
                $('#button-select-this-room-' + id).html(htmlNotSelected);
                $('#label-select-this-room-' + id).css('background-color', '#e0e0e0');
                hiddenRoomId.val('');
            }
        });

    });
}();
